/**
 * Canonical entitlement-error code list. Sub-spec #3 throws these from
 * requireEntitlement; sub-spec #2 throws SURFACE_SWITCH_RATE_LIMIT and
 * NO_STRIPE_CUSTOMER from the subscriptions Lambda; clients render their
 * own messaging per code.
 */

export const ENTITLEMENT_ERROR_CODES = [
  'NO_ENTITLEMENT_CREATE_FAMILY',
  'NO_ENTITLEMENT_INVITE_MEMBER',
  'NO_ENTITLEMENT_FAMILY_VAULT_ACCESS',
  'NO_ENTITLEMENT_RECOVERY',
  'SURFACE_NOT_ALLOWED',
  'NO_AVAILABLE_SUBSCRIPTION',
  'EMAIL_NOT_VERIFIED',
  'SURFACE_SWITCH_RATE_LIMIT',
  'NO_STRIPE_CUSTOMER',
  'NOT_YOUR_SUBSCRIPTION',
  'INVALID_WEBHOOK_SIGNATURE',
  'POOL_FULL',
  'TRIAL_FAMILY_LIMIT',
] as const;
export type EntitlementErrorCode = typeof ENTITLEMENT_ERROR_CODES[number];

export interface EntitlementErrorBody {
  code: EntitlementErrorCode;
  /** Set on SURFACE_NOT_ALLOWED — what surface the user IS allowed to use. */
  allowed?: 'extension' | 'mobile' | 'ios' | 'android' | null;
  /** Set on SURFACE_NOT_ALLOWED — the surface the user has currently picked. */
  pickedSurface?: 'extension' | 'mobile' | 'ios' | 'android';
  /** Optional human message for log surfacing; clients render their own copy. */
  message?: string;
}
